import { LazyLoader } from '@bp/ui-components';
import { Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import { AdminEvents } from '../../../components/AdminEvents/AdminEvents';
import { Page } from '../../../components/Page/Page';
import { usePermissionChecker } from '../../../hooks/usePermissionChecker';

export const EventsSubpage = () => {
  const { t } = useTranslation();
  const permissions = usePermissionChecker();

  return (
    <Page isForbidden={!permissions?.canManageAdministration()} title={t('routes.events.title')}>
      <Suspense fallback={<LazyLoader transparent forceHeight='50vh' fullWidth size='xxl' />}>
        <AdminEvents />
      </Suspense>
    </Page>
  );
};
